import { select, t } from '@lingui/core/macro';
import { ListItem, TeamAvatar, Tooltip, UserAvatar } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
import { AccessLevelSelection } from './AccessLevelSelection';
import { AvatarContainer } from './styled';
export function AccessListItem(props) {
    const { fieldName, type, hasAccessToParentFolder, title, subtitle, onRemove, visible } = props;
    const { isSubmitting } = useFormikContext();
    const tooltipTitle = t({
        comment: 'info tooltip in access list for existing folder/document: explanation why you can not remove access for current user/team',
        message: select(type, {
            user: `You can not modify access for this user because they have access to a parent folder`,
            team: `You can not modify access for this team because they have access to a parent folder`,
            other: `You can not modify access for this user/team because they have access to a parent folder`,
        }),
    });
    if (!visible) {
        return null;
    }
    return (<ListItem disabled={hasAccessToParentFolder || isSubmitting}>
      <AvatarContainer>
        {type === 'user' && <UserAvatar truncate size="md" title={title} subtitle={subtitle}/>}
        {type === 'team' && <TeamAvatar truncate size="md" title={title} subtitle={subtitle}/>}
      </AvatarContainer>

      <Tooltip title={tooltipTitle} disabled={!hasAccessToParentFolder}>
        <div>
          <AccessLevelSelection disabled={isSubmitting || hasAccessToParentFolder} name={fieldName} onRemove={onRemove}/>
        </div>
      </Tooltip>
    </ListItem>);
}
